import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserGuidePanelComponent } from './user-guide-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [UserGuidePanelComponent],
  exports: [UserGuidePanelComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
})
export class UserGuidePanelModule { }
